import React from "react";

export abstract class Guard {
    protected constructor(
        public fallback: React.ReactElement,
    ) {}

    abstract check(): boolean;
}
